export const labelStyles = 'mt-[16px] block font-extrabold text-[12px]/[14px]';
export const requiredStyles = 'text-[#F02D3A] text-[10px]/[14px] align-top';
export const inputStyles =
    'border-inner p-[10px] text-[16px]/[20px] border-[2px] rounded-[4px] focus:border-[3px] focus:outline-none';
export const sectionStyles = 'mt-[30px] text-[#949599] text-[18px/22px]';
